<div class="work-object-reject-mat-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="cancelIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "workobject.ui.reject.header.label" | translate }}
      </div>
    </span>
  </div>
  <div class="work-object-reject-mat-dialog-body">
    <form [formGroup]="paylaodFormGroup">
      <div fxLayout fxLayoutAlign="left top" fxLayoutGap="20px">
        <div style="padding-top: 6px">
          <mat-form-field whFlex="90">
            <mat-label>{{ "material.model.reason" | translate }}</mat-label>
            <mat-select formControlName="reason" required>
              <mat-option
                *ngFor="let rejectReason of ENUMS.REJECTION_REASON | whenum"
                [value]="rejectReason?.id"
              >
                {{ rejectReason?.translateKey | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div>
        <mat-form-field whFlex>
          <mat-label>{{
            "workobject.model.reject.comment" | translate
          }}</mat-label>
          <textarea
            matInput
            [rows]="10"
            [required]="false"
            [formControlName]="'comment'"
          ></textarea>
        </mat-form-field>
      </div>
    </form>
    <w-h-button-group align="end" mat-dialog-actions>
      <w-h-button
        [text]="'app.cancel.label' | translate | uppercase"
        matIcon="close"
        type="flat"
        [disabled]="saving"
        (clicked)="closeDialog()"
      />
      <w-h-button
        [text]="'app.save.label' | translate | uppercase"
        matIcon="save"
        [isLoading]="saving"
        color="accent"
        type="flat"
        [disabled]="isFormGroupInvalid"
        (clicked)="handleSubmit()"
      />
    </w-h-button-group>
  </div>
</div>
